import React from 'react'

import { mq } from 'marketing-site/src/library/utils'
import { IProps } from './index'
import { Text } from 'marketing-site/src/library/elements/Text'

export const InteractiveCardMini: React.FC<IProps> = ({ eyebrow, title, image, ctaUrl }) => {
  return (
    <div className="interactive-card-mini">
      <div className="interactive-card-mini__image">
        <a href={ctaUrl} className="interactive-card-mini__link">
          {image}
        </a>
      </div>

      <div className="interactive-card-mini__content">
        {eyebrow && (
          <div className="interactive-card-mini__eyebrow">
            <Text size="eyebrow">{eyebrow}</Text>
          </div>
        )}

        <a href={ctaUrl} className="interactive-card-mini__link">
          {title && (
            <div className="interactive-card-mini__title">
              <Text size="heading-6">{title}</Text>
            </div>
          )}
        </a>
      </div>

      <style jsx>
        {`
          .interactive-card-mini {
            display: flex;
            gap: 1rem;
            align-items: center;
            max-width: 25rem;

            &__link {
              display: flex;
              text-decoration: inherit;
              color: inherit;
            }

            &__image {
              flex: 0 0 46%;
              border-radius: 1rem;
              overflow: hidden;
              transition: transform 250ms;

              // The following lines will keep the ImageWithModalVideo
              // with an aspect ratio of 3:2 no matter the image size.
              & :global(.image-with-modal-video) {
                width: 100%;
              }

              & :global(picture) {
                width: 100%;
                height: 0;
                padding-bottom: calc(100% / 3 * 2);
                position: relative;
              }

              & :global(picture img) {
                position: absolute;
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: center;
              }
            }

            &__image:hover {
              transform: translateY(-4px);
              cursor: pointer;
            }

            &__eyebrow {
              margin-bottom: 0.75rem;
            }

            &__title {
              text-align: left;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }

            & :global(.play-button) {
              width: 2rem;
              height: 2rem;
            }
          }

          @media (${mq.tablet}) {
            .interactive-card-mini {
              grid-gap: 1.5rem;
            }
          }
        `}
      </style>
    </div>
  )
}
